var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.92485 14.8698C11.441 11.6343 16.453 9.50129 18.9607 8.47071C26.1209 5.5282 27.6087 5.01706 28.5784 5.00018C28.7917 4.99647 29.2686 5.04869 29.5775 5.29635C29.8383 5.50547 29.9101 5.78796 29.9444 5.98622C29.9788 6.18449 30.0215 6.63615 29.9876 6.98906C29.5995 11.0171 27.9206 20.7922 27.0665 25.3037C26.7051 27.2127 25.9934 27.8528 25.3045 27.9154C23.8072 28.0515 22.6703 26.9378 21.2201 25.9985C18.9509 24.5288 17.669 23.6139 15.4663 22.1798C12.9207 20.5224 14.5709 19.6114 16.0216 18.1227C16.4013 17.7331 22.9982 11.8045 23.1259 11.2667C23.1419 11.1994 23.1567 10.9487 23.0059 10.8163C22.8552 10.6839 22.6327 10.7292 22.4721 10.7652C22.2445 10.8162 18.6194 13.1836 11.5968 17.8673C10.5678 18.5654 9.63583 18.9056 8.80078 18.8878C7.8802 18.8681 6.10939 18.3735 4.79297 17.9507C3.17832 17.4321 1.89504 17.1579 2.00678 16.2772C2.06499 15.8185 2.70434 15.3494 3.92485 14.8698Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/_telegram.d57778f6d8ab28d8dc1d339e4f357be6.svg";
export { ForwardRef as ReactComponent };